import type Router from "vue-router"
import Page from "@/managers/session/page"
import Configuration from "@/managers/system/configuration"
import TimeoutAction from "@/utility/actions/timeoutAction"

let Install: typeof import("@/managers/system/install").default | undefined
import("@/managers/system/install").then(module => Install = module.default)

let Notifications: typeof import("@/managers/session/notifications").default | undefined
import("@/managers/session/notifications").then(module => Notifications = module.default)

function warning(message: string, error?: Error): void {
	if (Notifications !== undefined)
		Notifications.warning(message, error)
}

export default function(router: Router): void {
	router.beforeEach((to, from, next) => {
		if (Install !== undefined && Install.isUpdateReady && !Page.isUnloadPrevented && !from?.meta?.isUserBusy && !to?.meta?.isUserBusy) {
			const timeout = new TimeoutAction(
				() => {
					warning("Update application on navigation timed out")
					next()
				},
				Configuration.general.updateOnNavigationTimeout
			)
			try {
				Install.update(to.fullPath)
				timeout.clear()
			} catch (error: any) {
				timeout.clear()
				warning("Failed to update application on navigation", error)
				next()
			}
		} else
			next()
	})
}
